import { render, staticRenderFns } from "./ServiceSearchFacets.vue?vue&type=template&id=550ae80f"
import script from "./ServiceSearchFacets.vue?vue&type=script&lang=js"
export * from "./ServiceSearchFacets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports